import { CoverContent } from '@bnnvara/cards/src/components/deprecated/GridCard/CoverContent/CoverContent';
import {
  GridCard,
  LAYOUT_MINIMAL,
  LAYOUT_RECTANGLE,
  LAYOUT_SQUARE,
} from '@bnnvara/cards/src/components/deprecated/GridCard/GridCard';
import { ImageWithTextCard } from '@bnnvara/cards/src/components/ImageWithTextCard/ImageWithTextCard';
import { Author } from '@bnnvara/cards/src/components/shared/Author';
import { CommentCount } from '@bnnvara/cards/src/components/shared/CommentCount';
import { ContentOnImage } from '@bnnvara/cards/src/components/shared/ContentOnImage';
import { HideOnSmallDevices } from '@bnnvara/cards/src/components/shared/HideOnSmallDevices';
import { Small } from '@bnnvara/cards/src/components/shared/Small';
import { Title } from '@bnnvara/cards/src/components/shared/Title';
import { formatDate } from '@bnnvara/helpers';
import { CommentIcon } from '@bnnvara/icons/src/components/UserInterfaceIcons/CommentIcon';
import { SlotContent } from '@bnnvara/slot/src/component/SlotContent';
import PropTypes from 'prop-types';
import React from 'react';
import ReviewRating from '@bnnvara/rating';
import resizeImageSource from '../../../helpers/resizeImageSource';
import { CardLabel } from '../CardContent/CardLabel';

export const ArticleCard = ({
  title,
  publishDate,
  persons,
  thumbnail,
  commentCount,
  commentsEnabled,
  ariaLabelName,
  layout,
  categories,
  brand,
  isThemePage,
  subTheme,
  labelOverRide,
  review,
}) => {
  const image = thumbnail?.url || '/static/fallbackImages/videofallback.jpg';
  const pubDate =
    publishDate && formatDate(new Date(publishDate), 'dd-MM-yyyy');
  const backgroundImage = resizeImageSource(image, 500, 1);
  const authorName = persons && persons[0] ? persons[0].name : undefined;
  const brandName = brand?.name;
  if (layout === null) {
    return (
      <ImageWithTextCard
        aria-label={ariaLabelName}
        image={{
          alt: title,
          src: backgroundImage,
        }}
      >
        <SlotContent slot="image">
          {commentCount > 0 && commentsEnabled && (
            <CommentCount>
              <CommentIcon />
              {commentCount}
            </CommentCount>
          )}
          <HideOnSmallDevices>
            <ContentOnImage>
              <CardLabel
                brand={brand}
                categories={categories}
                subTheme={subTheme}
                variant="articleCard"
                overRide={labelOverRide}
              />
              <Title>{title}</Title>
              {review && (
                <ReviewRating
                  review={{
                    rating: review.rating,
                    type: review.type,
                    author: persons.length > 0 ? persons[0] : null,
                    itemReviewed: review.productName,
                    headline: title,
                    publicationDate: formatDate(
                      new Date(publishDate),
                      'yyyy-MM-dd HH:mm:ssxx'
                    ).replace(' ', 'T'),
                    reviewBody: null,
                    image: thumbnail?.url?.replace('/{format}', ''),
                  }}
                  variant="card"
                />
              )}
              <Small>
                {isThemePage && brandName && `${brandName}  • `} {pubDate}
                {authorName && <Author>{authorName}</Author>}
              </Small>
            </ContentOnImage>
          </HideOnSmallDevices>
        </SlotContent>
        <SlotContent slot="text">
          <CardLabel
            brand={brand}
            categories={categories}
            subTheme={subTheme}
            variant="articleCard"
            overRide={labelOverRide}
          />
          <Title>{title}</Title>
          {review && (
            <ReviewRating
              review={{
                rating: review.rating,
                type: review.type,
                author: persons.length > 0 ? persons[0] : null,
                itemReviewed: review.productName,
                headline: title,
                publicationDate: formatDate(
                  new Date(publishDate),
                  'yyyy-MM-dd HH:mm:ssxx'
                ).replace(' ', 'T'),
                reviewBody: null,
                image: thumbnail?.url?.replace('/{format}', ''),
              }}
              variant="card"
            />
          )}
          <Small>
            {isThemePage && brandName && `${brandName}  • `} {pubDate}
            {authorName && <Author>{authorName}</Author>}
          </Small>
        </SlotContent>
      </ImageWithTextCard>
    );
  }
  return (
    <GridCard layout={layout} aria-label={ariaLabelName}>
      <CoverContent
        title={title}
        pubDate={pubDate}
        backgroundImage={backgroundImage}
        commentCount={commentCount}
        commentsEnabled={commentsEnabled}
      />
    </GridCard>
  );
};

ArticleCard.defaultProps = {
  thumbnail: null,
  commentCount: 0,
  layout: null,
  isThemePage: false,
  name: '',
  labelOverRide: null,
};

ArticleCard.propTypes = {
  thumbnail: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }),
  brand: PropTypes.shape({
    name: PropTypes.string,
  }),
  title: PropTypes.string.isRequired,
  name: PropTypes.string,
  publishDate: PropTypes.string.isRequired,
  persons: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      slug: PropTypes.string,
    })
  ).isRequired,
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    })
  ).isRequired,
  subTheme: PropTypes.shape({
    id: PropTypes.string,
    slug: PropTypes.string,
    name: PropTypes.string,
    color: PropTypes.string,
    colorHover: PropTypes.string,
    colorActive: PropTypes.string,
    colorVisited: PropTypes.string,
  }),
  commentCount: PropTypes.number,
  commentsEnabled: PropTypes.bool,
  ariaLabelName: PropTypes.string,
  isThemePage: PropTypes.bool,
  layout: PropTypes.shape({
    mobile: PropTypes.oneOf([LAYOUT_MINIMAL, LAYOUT_SQUARE]),
    tablet: PropTypes.oneOf([LAYOUT_MINIMAL, LAYOUT_RECTANGLE, LAYOUT_SQUARE]),
    desktop: PropTypes.oneOf([LAYOUT_RECTANGLE, LAYOUT_SQUARE]),
  }),
  labelOverRide: PropTypes.string,
  review: PropTypes.shape({
    type: PropTypes.string,
    rating: PropTypes.string,
    productName: PropTypes.string,
  }),
};

export default ArticleCard;
